import VNavigationDrawer from './VNavigationDrawer'

VNavigationDrawer.install = function install (Vue) {
  Vue.component(VNavigationDrawer.name, VNavigationDrawer)
}

export default VNavigationDrawer



// WEBPACK FOOTER //
// ./src/components/VNavigationDrawer/index.js